var _path, _path2, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarmBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 62,
    viewBox: "0 0 262 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.873 43.1644C28.8589 43.1644 8.75403 52.4109 -8 56.4794V82H269V1C256.155 25.411 201.984 64.2466 176.853 48.7123C151.722 33.1781 121.006 53.1507 103.135 53.1507C85.2641 53.1507 76.8871 43.1643 52.873 43.1644Z",
    fill: "url(#paint0_linear_15_4594)",
    fillOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-8 57C8.75403 52.8933 28.8589 43.56 52.873 43.56C76.8871 43.56 85.2641 53.64 103.135 53.64C121.006 53.64 151.722 33.48 176.853 49.16C201.984 64.84 256.155 25.64 269 1",
    stroke: "url(#paint1_linear_15_4594)",
    strokeOpacity: 0.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.5,
    cy: 53.5,
    r: 2,
    fill: "white",
    stroke: "#F56527"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 43.5,
    r: 2,
    fill: "white",
    stroke: "#F56527"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 225.5,
    cy: 41.5,
    r: 2,
    fill: "white",
    stroke: "#F56527"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15_4594",
    x1: 130,
    y1: 3,
    x2: 130.5,
    y2: 72.5685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA4A4A",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703386,
    stopColor: "#FF000F",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB099",
    stopOpacity: 0.51
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15_4594",
    x1: 130,
    y1: 19,
    x2: 130,
    y2: 69.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4884FA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarmBg);
export default __webpack_public_path__ + "static/media/warm-bg.860eb0e8dfb1bfff00fe71958315e879.svg";
export { ForwardRef as ReactComponent };